import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { DesignerShell } from "./DesignerShell";

/**
 * Layout route for the authenticated designer portal.
 *
 * Renders the shared <DesignerShell/> ONCE and swaps page content via <Outlet/>,
 * so the sidebar + top bar stay mounted (no re-animation / auth re-check on
 * navigation between sections). The inner <Suspense> catches lazy page-chunk
 * loads in the content area only — otherwise the first visit to each section
 * would blank the whole shell with a full-screen spinner (reads as a refresh).
 */
export const DesignerLayout = () => (
  <DesignerShell>
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] flex-1 items-center justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  </DesignerShell>
);

export default DesignerLayout;
